import { Box, Card, Link, Typography } from '@mui/material';
import config from '../../config';
import { useFromQueryParam } from '../../helpers/getFromQueryParam';
import NotFoundImage from '../../assets/images/not_found.png';

function LinkDisable() {
    const from = useFromQueryParam();
    const linkTop = config.defaultPath;
    return (
        <Card style={{ textAlign: 'center', padding: '30px 20px', borderRadius: '25px' }}>
            <img src={NotFoundImage} style={{ maxWidth: 150 }} alt="logo" />
            <Typography variant="h2" mt={1}>
                URLが無効になりました。
            </Typography>
            {from !== 'app' && (
                <Box mt={3}>
                    <Link
                        fontSize={22}
                        underline="hover"
                        href={linkTop}
                        onClick={() => {
                            localStorage.removeItem('token');
                        }}
                        style={{
                            fontWeight: 700
                        }}
                    >
                        TOPページへ
                    </Link>
                </Box>
            )}
        </Card>
    );
}

export default LinkDisable;
